TS.ns('WL');

WL.documentTypeTransitionModel = new Class({
    Extends: TS.domain.EditDomain,

    createProperties: function (config) {
        var me = this;

        me.parent(config);
        var transitionList = me.getDomainProperty('TransitionList');

        if (transitionList != null) {
            transitionList.on('addNew', me.onTransitionAdded);
            transitionList.addFirst = true;
        }
    },

    onTransitionAdded: function (e) {
        var me = this,
         rec = e.item;

        rec.TransitionXActionCollection = ko.observableArray([]);
    }
});